import { useEffect, useRef } from 'react';

import { useLocation } from 'react-router-dom';

// overlay scrollbars
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';

function navigation_scroll(instance) {
    if (!instance) return;
    
    const viewport = instance.elements().viewport;
    const scroll_position = viewport.scrollTop;
    const navigation = document.querySelector('.navigation');
  
    if (typeof(navigation) === 'undefined' || navigation === null) return;
  
    if (window.innerWidth > 991 && scroll_position > 0)  {
        navigation.classList.add('scrolled');
    } else if (window.innerWidth < 991 && scroll_position > 0)  {
        navigation.classList.add('scrolled');
    }
    else {
        navigation.classList.remove('scrolled');
    }
};

const CustomScrollbar = () => {
    
    let scrollbar = useRef();

    useEffect(() => {
        scrollbar.current = OverlayScrollbars(document.querySelector('body'), {
            overflow: {
                x: "hidden",
                y: "scroll"
            }
        });

        // Add scroll event listener
        if (scrollbar.current) {
            scrollbar.current.on('scroll', () => {
                navigation_scroll(scrollbar.current);
            });
        }

        return () => {
            if (scrollbar.current) {
                scrollbar.current.destroy();
            }
        }
    }, []);

    let path = useLocation().pathname;

    useEffect(() => {
        if (scrollbar.current) {
            navigation_scroll(scrollbar.current);
        }
    }, [path]);

    return null;
};

export default CustomScrollbar;
